import React from 'react';
import { LOGIN_STATE } from '@xingternal/xing-frame-provider';

import Header from './Header';

export const LoggedOutHeader = props => (
  <Header loginState={LOGIN_STATE.loggedOut} {...props} />
);
export default Header;
